import styled from 'styled-components';
import { CheckmarkIc } from '@dsch/dd-icons';
import { Tooltip } from '../../../../../components/Toolkit/Tooltip/Tooltip';
import getConfig from 'next/config';

type TItem = {
  title: string;
  description?: string;
  toolTip?: {
    title: string;
    description: string;
  };
};

const {
  publicRuntimeConfig: { CDN_STATIC_ASSETS },
} = getConfig();

export interface IBulletPointList {
  points?: TItem[];
  className?: string;
}

const List = styled.ul`
  display: grid;
  grid-template-rows: 1fr;
  row-gap: 8px;
`;

const ListItem = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  column-gap: 8px;
`;

const Checkmark = styled(CheckmarkIc)`
  color: ${({ theme }) => theme.colors.GREEN};
`;

const Title = styled.p<{ underline?: boolean }>`
  ${({ theme }) => theme.fontSize.B14};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  text-decoration: ${({ theme, underline }) =>
    underline ? `underline dashed ${theme.colors.GREY_DARK}` : undefined};
  text-underline-offset: ${({ theme, underline }) =>
    underline ? `${theme.spacing.S4}` : undefined};
`;

const Description = styled.p`
  ${({ theme }) => theme.fontSize.S12};
  grid-column-start: 2;
`;

function iconSelector(iconName: string) {
  switch (iconName) {
    case 'Spotlight':
      return `${CDN_STATIC_ASSETS}/images/illustrations/spotlight.svg`;
    case 'Bump':
      return `${CDN_STATIC_ASSETS}/images/illustrations/bump.svg`;
    case 'Ad performance analytics':
      return `${CDN_STATIC_ASSETS}/images/illustrations/analytics.svg`;
    default:
      return undefined;
  }
}

function BulletPointList({ points, className }: IBulletPointList) {
  return (
    <List className={className}>
      {points &&
        points.map(({ title, description, toolTip }, index) => (
          <li key={index}>
            {toolTip?.title ? (
              <ListItem>
                <Checkmark width="16" height="16" />
                <Tooltip
                  title={toolTip.title}
                  subtitle={toolTip?.description}
                  includeHover
                  iconSrc={iconSelector(toolTip.title)}
                  arrowPosition={['left', 'left', 'center']}
                  hideCloseOptionOnDesktop
                  tooltipPosition="above"
                >
                  <Title underline={Boolean(index >= 2)}>{title}</Title>
                  {description && <Description>{description}</Description>}
                </Tooltip>
              </ListItem>
            ) : (
              <ListItem>
                <Checkmark width="16" height="16" />
                <Title underline={Boolean(index >= 2)}>{title}</Title>
                {description && <Description>{description}</Description>}
              </ListItem>
            )}
          </li>
        ))}
    </List>
  );
}

export { BulletPointList };
